/* eslint-disable @nx/enforce-module-boundaries */
import { Routes } from '@angular/router';
import { RoutesValues } from './common/enums/routes.enum';
import { LayoutComponent } from './layout/layout.component';
import { AUTH_GUARD } from './features/auth/guards/auth.guard';
import { ADMIN_AUTH_GUARD } from './features/auth/guards/adminAuth.guard';
import { SOCIUM_ADMIN_GUARD } from './features/auth/guards/sociumAdmin.guard';
import { UserRole } from '@socium/sociumflow';
import { PERMISSION_ONLY } from '@socium/common-api';

/**
 * Route Configuration structure:
 */
export const routes: Routes = [
  {
    path: '',
    redirectTo: RoutesValues.AUTH,
    pathMatch: 'full',
  },
  {
    path: RoutesValues.AUTH,
    loadChildren: () =>
      import('./routes/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AUTH_GUARD],
    children: [
      {
        path: RoutesValues.HOME,
        loadChildren: () =>
          import('./routes/dashboard/dashboard.routes').then(
            (m) => m.dashboardRoutes,
          ),
        pathMatch: 'full',
        data: {
          profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
        },
      },
      {
        path: RoutesValues.PROFILE,
        loadChildren: () =>
          import('./routes/profile/profile.routes').then(
            (m) => m.profileRoutes,
          ),
        pathMatch: 'full',
        data: {
          profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
        },
      },
      {
        path: RoutesValues.DOCUMENT_REQUESTS,
        loadChildren: () =>
          import('./routes/document-requests/document-request.routes').then(
            (m) => m.documentRequestRoutes,
          ),
        data: {
          profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
        },
      },
      {
        path: RoutesValues.MODELS,
        loadChildren: () =>
          import('./routes/models/model.routes').then((m) => m.modelRoutes),
        data: {
          profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
        },
        canActivate: [ADMIN_AUTH_GUARD],
      },
      {
        path: RoutesValues.SETTINGS,
        loadChildren: () =>
          import('./routes/settings/setting.routes').then(
            (m) => m.settingRoutes,
          ),
        data: {
          profiles: [UserRole.HOLDING_ADMIN],
        },
        canActivate: [ADMIN_AUTH_GUARD],
      },
      {
        path: RoutesValues.CONTRACTS,
        loadChildren: () =>
          import('./routes/contracts/contract.routes').then(
            (m) => m.contractRoutes,
          ),
        data: {
          profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
        },
      },
      {
        path: RoutesValues.COUNTRY_CONFIG,
        loadChildren: () =>
          import('./routes/country-config/country-config.routes').then(
            (m) => m.countryConfigRoutes,
          ),
        data: {
          profiles: PERMISSION_ONLY,
        },
        canActivate: [SOCIUM_ADMIN_GUARD],
      },
      {
        path: RoutesValues.EMPLOYEES,
        loadChildren: () =>
          import('./routes/employees/employee.routes').then(
            (m) => m.employeeRoutes,
          ),
        data: {
          profiles: [UserRole.HOLDING_ADMIN],
        },
      },
      {
        path: RoutesValues.COMPLIANCES,
        loadChildren: () =>
          import('./routes/compliances/compliances.routes').then(
            (m) => m.complianceRoutes,
          ),
        data: {
          profiles: [UserRole.HOLDING_ADMIN],
        },
      },
      {
        path: RoutesValues.PAYSLIPS,
        loadChildren: () =>
          import('./features/payslips/payslips.route').then(
            (m) => m.payslipRoutes,
          ),
        data: {
          profiles: [UserRole.HOLDING_ADMIN, UserRole.EMPLOYEE],
        },
      },
    ],
  },
  {
    path: RoutesValues.GUESTS,
    loadChildren: () =>
      import('./routes/guests/guest.routes').then((m) => m.guestRoutes),
  },
  {
    path: RoutesValues.FORBIDDEN,
    loadChildren: () =>
      import('./routes/forbidden/forbidden.routes').then(
        (m) => m.forbiddenRoutes,
      ),
  },
  {
    path: RoutesValues.NOT_FOUND,
    loadChildren: () =>
      import('./routes/not-found/not-found.routes').then(
        (m) => m.notFoundRoutes,
      ),
  },
  { path: '**', redirectTo: RoutesValues.NOT_FOUND },
];
